<template>
    <div id="call-support" class="call-show" style=" position: fixed; bottom: 5px; right: 0; height: 50px; z-index: 9999; padding-right: 5px; background-color: #dd4b39">
        <label style="position: relative; display: block; color:#fff">
            <a @click="toggle" title="">
                <span style="margin: 0 5px 0 -25px; display: inline-block; vertical-align: middle; -webkit-border-radius: 50%; -moz-border-radius: 50%; border-radius: 50%; width: 50px; height: 50px; cursor: pointer; background-position: center; background-color: #dd4b39; font-size: 24px; color: white; border: 3px solid #dd4b39;">
                    <i style="margin-left: 2px; margin-top: 2px; border-radius: 50%; border: 2px solid #fff; padding: 8px; height: 40px; width: 40px; " class="fa fa-phone" aria-hidden="true"></i>
                </span>
                <p style="display: inline-block; vertical-align: middle; color: #fff; font-size: 12px; margin:0px">Điện thoại hỗ trợ<br> <strong style="font-size:16px">(024)-7301 9666 nhánh 1 </strong></p>
            </a>
            <i></i>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'TheCallSupport',
        data() {
            return {
                minimize: false
            }
        },
        created() {

        },
        methods: {
            toggle() {
                if ($('#call-support').hasClass('call-show')) {
                    $("#call-support").stop(true, false).animate({ right: "-200" }, "medium", 'swing', function () {
                        $("#call-support").removeClass('call-show');
                    });
                }
                else {
                    $("#call-support").stop(true, false).animate({ right: "0" }, "medium");
                    $("#call-support").addClass('call-show');
                }
            }
        },
        watch: {

        }
    }
</script>
